import mainLogo from '../../images/Nissul/nissul_azul.png';
import squareLogo from '../../images/Nissul/nissul_azul.png';
import mainLogoWhite from '../../images/Nissul/Logo_Grupo_NissulGala_Branco.png';
import smallLogoWhite from '../../images/Nissul/Logo_Grupo_NissulGala_Branco_small.png';
import banner01 from '../../images/Nissul/concessionaria_faixa_4.jpg';
import banner02 from '../../images/Nissul/concessionaria_faixa_nissul_2.webp';
import banner03 from '../../images/Nissul/concessionaria_faixa_nissul_3.webp';
import car123 from '../../images/Nissul/123_creta.jpg';
import box123 from '../../images/Nissul/123_nissul.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Nissul',
    defaultStoreLink: 'nissulgala.shop',
    defaultContactEmail: 'atendimento@nissulgala.com',
    whatsappNumber: '53 3025 8400',
    CNPJ: '',
    CNPJname: '',
    CNPJaddress: '',
    launchDate: '12/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "hyundai",
        "jeep",
        "renault",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Nissul Pelotas",
        "NISSUL GALA JEEP BAGÉ",
        "NISSUL GALA HYUNDAI PELOTAS",
        "NISSUL GALA JEEP PELOTAS",
        "Gala Canoas",
        "NISSUL YAMAHA RIO GRANDE",
        "NISSUL CAOA CHERY PELOTAS",
        
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogoWhite,
    squareLogo: smallLogoWhite,
    bannerImg01: mainLogoWhite,
    bannerLogoWhite: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: '',
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Nissul</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo Nissul Gala tem mais de 20 anos de história e representa as marcas Caoa Chery, GWM, Hyundai, Jeep, Ram, Renault e Yamaha.',
            'Iniciou sua operação em Pelotas no ano de 1999 propondo-se a ser a melhor revenda autorizada de veículos da região sul, disponibilizando aos clientes as melhores marcas, produtos, serviços e possibilitando a existência de um vínculo forte e duradouro.',
            'Durante sua trajetória, expandiu-se pelo estado com a representação de novas marcas, conquistando crescimento, progresso e consolidação. Atualmente possui sede nas cidades de Bagé, Cachoeirinha, Camaquã, Canoas, Guaíba, Pelotas e Rio Grande, contando com mais de 350 colaboradores em suas mais de 15 unidades.',
        ],
        link: 'https://www.nissulgala.com.br/sobre-nos/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/nissulgala/',
        Facebook: 'https://www.facebook.com/NissulGala/',
        LinkedIn: 'https://www.linkedin.com/company/nissulgala/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}